import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as Papa from 'papaparse';

import { API_URL, ENDPOINTS } from '../../constants/api';
import { CSVLink } from 'react-csv';

const CSVUploader = () => {
  const [tables, setTables] = useState([]);
  const [columns, setColumns] = useState([]);
  const [selectedTable, setSelectedTable] = useState('');
  const [csvData, setCsvData] = useState(null);
  const [columnMapping, setColumnMapping] = useState({});
  const [errorRecords, setErrorRecords] = useState([]);
  const [successRecords, setSuccessRecords] = useState([]);

  useEffect(() => {
    // Fetch MySQL tables from backend
    axios.get(`${API_URL}/${ENDPOINTS.SYS}/tables`).then((res) => {
      setTables(res.data);
    });
  }, []);
  console.log(tables);

  const handleTableChange = (tableName) => {
    setSelectedTable(tableName);

    axios
      .get(`${API_URL}/${ENDPOINTS.SYS}/columns/${tableName}`)
      .then((res) => {
        console.log('columns:', res.data);

        // Extract only the column names (Field)
        const tableColumns = res.data.map((col) => col.Field);
        setColumns(tableColumns);

        // Set default mapping: CSV column names will match MySQL column names by default
        const defaultMapping = tableColumns.reduce((mapping, col) => {
          mapping[col] = col; // Each column maps to itself by default
          return mapping;
        }, {});

        setColumnMapping(defaultMapping);
      })
      .catch((error) => console.error('Error fetching columns:', error));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      complete: (result) => {
        setCsvData(result.data);
      },
      header: true, // Parses first row as column names
      skipEmptyLines: true,
    });
  };

  const handleColumnMapping = (csvColumn, mysqlColumn) => {
    setColumnMapping((prev) => {
      // Create a new object without the existing mapping for this value
      const updatedMapping = Object.fromEntries(
        Object.entries(prev).filter(([key, value]) => value !== mysqlColumn)
      );

      // Add the new mapping
      updatedMapping[csvColumn] = mysqlColumn;

      console.log('Updated columnMapping:', updatedMapping);
      return updatedMapping;
    });
  };

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append('file', csvData);
    formData.append('table', selectedTable);
    formData.append('mapping', JSON.stringify(columnMapping));

    const response = await axios.post(
      `${API_URL}/${ENDPOINTS.SYS}/csv-uploader`,
      formData
    );
    console.log('res:', response);
    alert('CSV Uploaded Successfully!');
  };

  // Send Data to API
  const handleUploadToServer = () => {
    // formData.append('file', csvData);
    // formData.append('table', selectedTable);
    // formData.append('mapping', JSON.stringify(columnMapping));

    axios
      .post(`${API_URL}/${ENDPOINTS.SYS}/upload-csv`, {
        data: csvData,
        table: selectedTable,
        columns: columns.join(', '),
      })
      .then((res) => {
        setSuccessRecords(res.data.success);
        setErrorRecords(res.data.errors);
        console.log('res:', res.data);
      })
      .catch((err) => console.error('Upload Error:', err));
  };

  console.log('columns:', columns, 'columnMapping:', columnMapping);

  return (
    <div className="container">
      <h2>Upload CSV to MySQL</h2>

      <div className="d-flex align-items-start flex-wrap gap-3">
        <div className="d-flex flex-column mb-3">
          <label className="form-label text-capitalize font-weight-bold">
            Select Table:
          </label>
          <select
            onChange={(e) => handleTableChange(e.target.value)}
            className="form-select"
          >
            <option value="">Select a Table</option>
            {tables &&
              tables.length > 0 &&
              tables.map((table) => (
                <option key={table} value={Object.values(table)[0]}>
                  {Object.values(table)[0]}
                </option>
              ))}
          </select>
        </div>
        <div className="d-flex flex-column mb-3">
          <label className="form-label text-capitalize font-weight-bold">
            Choose Csv File:
          </label>
          <input
            type="file"
            className="form-control"
            accept=".csv"
            onChange={handleFileChange}
          />
        </div>
        <div className="d-flex flex-column mb-3">
          <label
            htmlFor=""
            className="form-label text-capitalize font-weight-bold"
          >
            <span className="text-danger">&nbsp;</span>
          </label>
          <button className="btn btn-primary" onClick={handleUploadToServer}>
            Upload
          </button>
        </div>

        {columns.length > 0 && (
          <div>
            <h3>Selected table columns</h3>

            <>
              <span>{columns.join(', ')}</span>
            </>
          </div>
        )}
      </div>

      {errorRecords && errorRecords.length > 0 && (
        <>
          <h2>
            ❌ Failed Uploads -{' '}
            <CSVLink
              data={errorRecords}
              filename={selectedTable + '-error.csv'}
              className="btn btn-danger mr-2"
            >
              Export CSV
            </CSVLink>
          </h2>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {Object.keys(errorRecords[0]).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                  <th>Error Message</th>
                </tr>
              </thead>
              <tbody>
                {errorRecords.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((val, idx) => (
                      <td key={idx}>{val}</td>
                    ))}
                    <td>{row.error}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {successRecords && successRecords.length > 0 && (
        <>
          <h2>
            ✅ Successfully Uploads -{' '}
            <CSVLink
              data={successRecords}
              filename={selectedTable + '-success.csv'}
              className="btn btn-success mr-2"
            >
              Export CSV
            </CSVLink>
          </h2>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {Object.keys(successRecords[0]).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {successRecords.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((val, idx) => (
                      <td key={idx}>{val}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {csvData && csvData.length > 0 && (
        <>
          <h2>CSV Preview</h2>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {Object.keys(csvData[0]).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {csvData.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((val, idx) => (
                      <td key={idx}>{val}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default CSVUploader;
